
type LogLevel = 'info' | 'warn' | 'error' | 'debug';

class FrontendLogger {
  private isDebugEnabled(): boolean {
    return localStorage.getItem('DEBUG_MODE') === 'true' || import.meta.env.DEV;
  }

  private formatMessage(level: LogLevel, message: string, data?: any): string {
    const timestamp = new Date().toLocaleTimeString();
    return `[${timestamp}] [${level.toUpperCase()}] ${message}`;
  }

  info(message: string, data?: any) {
    console.log(`%c${this.formatMessage('info', message)}`, 'color: #2196F3', data || '');
  }

  warn(message: string, data?: any) {
    console.warn(this.formatMessage('warn', message), data || '');
  }

  error(message: string, error?: any) {
    console.error(this.formatMessage('error', message), error || '');
  }

  debug(message: string, data?: any) {
    if (this.isDebugEnabled()) {
      console.log(`%c${this.formatMessage('debug', message)}`, 'color: #9E9E9E', data || '');
    }
  }
}

export const logger = new FrontendLogger();
